// recovered due to lost connection on the VPN..

pyzel.surfboard_models = {
	
	default : function(){			

		//alert();

		console.log( 'surfboard models loaded' );
		console.log( window.location.hash );

		// disable default behaviour on the submenu
		// and do some anim on the scroll

		$('.js-submenu-surfboards .model-link').on('click', e => {

			//console.log('scrolling on menu click');

			e.preventDefault();

			//console.log( $(e.target).prop('href').split('#')[1] );

			let category = $(e.target).prop('href').split('#')[1];
			let el = $('#'+category );

			//console.log( "el:" );
			//console.log( el.offset().top );

			//$("body").stop().animate({
			$("html").stop().animate({
  			
  				scrollTop: el.offset().top - 100 }, 2000, function(){ 

  					window.location.hash = category;
  					console.log("animation stopped");

  				});

			})

			let html = '';

			// get models

			$.ajax({

				//url: endpoint+'/surboardmodeltypes',
				//url: 'http://antonio.shaperbuddy.com/api/v1/surfboardmodeltypesdescription?lang=en',
				url: endpoint+'/surfboardmodeltypesdescription?lang=en',
				method: 'get'

			}).done( r => {

				//console.log( r );
				//return false;

				let total_models = Object.keys(r).length;
				let loop_models = 0;
				//console.log( total_models );

				//$.each( r, ( k, i ) =>{
				$.each( r, ( k, i ) =>{

					loop_models++;
					
					//console.log( "i.name" );
					//console.log( i.name );
					//console.log( "i.id" );
					//console.log( i.id );

					//return false;

					//console.log( loop_models );
					
					html = `
					
					<div class="container-fluid surfboard-listing" id="surfboard-listing-${ i.id }">
						<div class="col-sm-12 col-md-3 details" id="${ pyzel.helpers.safe_name( i.name ) }">
						<div class="title">${ i.name }</div>
						<p class="description">

							${ i.description }

						</p>
						<div class="btn btn-primary js-surfboards-view-all hide" data-id-category="${ i.id }" id="btn-view-all-${ i.id }">
							View all
						</div>
					</div>
					<!-- Boards -->
						<div class="col-sm-12 col-md-9 js-boards-list-slider" id="models-of-category-${ i.id }"></div>
					</div>`;

					$('#models-placeholder').append( html );
					// now get board of this model
					//console.log('ended '+i.surfboardmodel);				

					var display_mode;

					if( window.location.hash == '#all' )
						var display_mode = 'all';

					pyzel.surfboard_models.models_per_category( i.id, 0, display_mode ).then( ()=> {

						if( total_models == loop_models ){
					
							//console.log('ended models loop?');

							if( window.location.hash != '' &&  window.location.hash != '#all' ){

								//console.log('scrolling on location hash');
		
								let category = window.location.hash.replace('#', '');
								//console.log( category );
								//console.log( $('#'+category) );
								let el = $('#'+category);
								//console.log('distance of element is:');
								//console.log( el.offset().top );							
								$("body").stop().animate({ scrollTop: el.offset().top - 100 }, 2000, function() { 
								
									//console.log('finished animation');

								});

							}
						}

					});

					// this can only happen after this ^
					// or the model description must have a defined height
					/*
					if( total_models == loop_models ){
					
						console.log('ended models loop?');

						if( window.location.hash != '' ){

							console.log('scrolling on location hash');
	
							let category = window.location.hash.replace('#', '');
							console.log( category );
							console.log( $('#'+category) );
							let el = $('#'+category);
							console.log('distance of element is:');
							console.log( el.offset().top );							
							$("body").stop().animate({ scrollTop: el.offset().top - 100 }, 2000, function() { 
							
								console.log('finished animation');

							});

						}
					}
					*/
			}) // end each model			

			$( '#model-link-'+window.location.hash.replace('#', '') ).trigger('click');

		})

		
		$(document).on('click', '.js-surfboards-view-all', function( e ){
			
			//console.log( e.originalEvent );
			//console.log( e.currentTarget );		
			
			let el = $( e.target );
			el.html('loading..');			
			e.preventDefault();		
			//pyzel.surfboard_models.models_per_category( el.data('id-category'), 3, e.originalEvent );			
			pyzel.surfboard_models.models_per_category( el.data('id-category'), 3 );			

		})
		

	}, // end default

	/**
	* gets the model of category
	*
	* @return {void}
	*/

	models_per_category: function( id_category, start = 0, display_mode ){

		/*
		console.log( "id_category" );
		console.log( id_category );
		console.log( "start" );
		console.log( start );
		*/

		//console.log( 'display_mode' );
		//console.log( display_mode );

		// store the models
		//let models_of_category = [];
		// it should cache

			return $.when(

			$.ajax({
				url: endpoint+
				'/surfboardmodels?id_surfboardmodeltype='+id_category,
				method: 'get'
			}).done( r => {
				
				
				let html = '';

				if( r.length < 3 )			
					$('#btn-view-all-'+id_category).hide();
					//console.log( r );
					
				// API does not limit the results, so
				// cut the array - chop chop

				if( start == 0 && display_mode == undefined ){

					r = r.slice( 0, 3 );
					$('.js-surfboards-view-all').removeClass('hide');

				}else if( display_mode == 'all' ){
					r = r; // redundant..
					//$('.js-surfboards-view-all').hide();
				}					
				else {
					r = r.slice( 3 );
					$('.js-surfboards-view-all').removeClass('hide');
				}					
					
				$.each( r, ( k, i ) => {
					
					html += 

					`<div class="col-sm-4">
						
						<a href="index.php?page=surfboard-details&id=${ i.id_surfboardmodel }" class="slide surfboard-listing-single">

							<div class="name">
								${ i.surfboardmodel }
							</div>
							
							<div class="price">
								${ i.min_price } EUR
							</div>

							<!-- make images adaptive -->
							<img src="${ i.img_dynamic }?w=340&h=520&fit=crop" srcset="${ i.img_dynamic }?w=340&h=520&fit=crop 1200w" alt="${ i.surfboardmodel }" width="340" height="425">

							<div class="category">
								${ i.surfboardmodeltype }
							</div>

							<div class="specs"> 

								${ i.wavesize.min }-${ i.wavesize.max }${ i.wavesize.measure } / ${ pyzel.helpers.skill_level( i.skilllevel ) }
							
							</div>
							
							<div class="btn btn-primary btn-sm">

								See more

							</div>

						</a>

					</div>`;
					
			
			}) // end each

				$('#models-of-category-'+id_category).append( html );

				//console.log('here i got.');

				//console.log( 'trigger' );
				//console.log( trigger );

				// scroll to new loaded boards
				//if( start != 0 && trigger !== 'undefined' ){
				if( start != 0 ){

				// 800 ~ height of board

					//console.log('start != 0');

					$("body").stop().animate({ scrollTop: $(window).scrollTop() + 800  }, 2000, function() { 

						$('#btn-view-all-'+id_category).fadeOut(1000);

						//console.log('animation stopped?');

					});

				}else{

					//console.log('start is: '+start);

				}

			}) // end done get board per model?			

			)// end when								
			
		//console.log('this does not happen, because of the return statment.');	
	
	//}); // end done get board per model?
	
	} // end get model per category

}// end namespace